<template>
  <div class="body">
      <!-- 左侧结束 -->
      <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
        <el-form-item label="标题：">
          <el-input placeholder="请输入标题" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="论坛分类：">
          <el-select clearable v-model="form.cid" placeholder="选择论坛分类" class="news-select">
            <el-option  v-for="(item, index) in type" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频：" >
            <div class="pic_img">
                <div class="pic_img_box">
                    <el-upload class="avatar-uploader"
                               action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcordssp"
                               v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                               v-bind:on-progress="uploadVideoProcess"
                               v-bind:on-success="handleVideoSuccess"
                               v-bind:before-upload="beforeUploadVideo"
                               v-bind:show-file-list="false">
                        <video v-if="videoForm.showVideoPath !='' && !videoFlag"
                               v-bind:src="videoForm.showVideoPath"
                               class="avatar video-avatar avatars"
                               controls="controls">
                            您的浏览器不支持视频播放
                        </video>
                        <i v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                           class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoFlag == true"
                         type="circle"
                         v-bind:percentage="videoUploadPercent"
                         style="margin-top:7px;"></el-progress>
                    </el-upload>
                </div>
            </div>
            <p class="Upload_pictures">
                <span></span>
                <span>最多可以上传1个视频，建议大小200M，推荐格式mp4</span>
            </p>
        </el-form-item>
        <el-form-item label="论坛内容：" >
          <el-input
            class="textarea-ipt"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6}"
            placeholder="请填写论坛内容"
            v-model="form.content">
          </el-input>
        </el-form-item>




        <el-form-item>
          <el-button type="primary" @click="onSubmit_tj(form)" size="medium">提交</el-button>
        </el-form-item>
      </el-form>
      <div class="clear"></div>
  </div>

</template>

<script>

export default{
  data(){
    return {
      loading:true,
      type:{},

      form: {
        cid:'',
        title:'',
        content:'',
     },
     // 上传视频
     videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
     			  showVideoPath: ''
      },
      sp:'',
    }
  },
  props:['productid','title'],
  components: {

  },

  mounted () {
    console.log(this.productid)
    this.form.title = this.title
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        that.$api.post("/Products/Jobstype",{}).then(res => {
          console.log(res);
          that.type= res.type;
          // that.form= res.form;
         this.loading = false
        });
    },


    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },



    onSubmit_tj(form) {
      var that = this;


      var userid = that.$cookieStore.getCookie('userid');
      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      that.form.userid = userid;
      that.form.huifuuid = 0;
      that.form.status = 1;
      that.form.sp = that.sp;
      that.form.picarrs = '';
      console.log(this.form);
      that.$api.post("/Products/jobsFabu",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
        that.form.cid='';
        that.form.content='';
        that.form.title='';
        that.sp="";
        that.videoForm.showVideoPath ="";

        this.$emit('handleClose');
      });
    },
    //上传前回调
    beforeUploadVideo(file) {
      console.log(file);
        var fileSize = file.size / 1024 / 1024 < 200;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
           this.$message.error("请上传正确的视频格式");
            return false;
        }
        if (!fileSize) {
            this.$message.error("视频大小不能超过200MB");
            return false;
        }
        this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;

        //前台上传地址
        //if (file.status == 'success' ) {
        //    this.videoForm.showVideoPath = file.url;
        //} else {
        //     layer.msg("上传失败，请重新上传");
        //}

        //后台上传地址
        if(res.code == 0){
          this.videoForm.showVideoPath = res.data;
          this.sp = res.path;
        }else{
            // layer.msg(res.Message);
            console.log(res);
        }
    }


  }

 }
</script>



// WEBPACK FOOTER //
// src/components/public/jobsFaubu.vue